export interface ArticleGroup {
  top?: string
  sub?: string
  count: number
}

export interface ArticleGroupSlice<T> extends ArticleGroup {
  articles: T[]
}

export function buildArticleGroupSlices<T>(
  groups: ArticleGroup[] | undefined,
  articles: T[] | undefined,
): ArticleGroupSlice<T>[] {
  if (!articles?.length) {
    return []
  }
  if (!groups?.length) {
    return [{ count: articles.length, articles }]
  }

  const slices: ArticleGroupSlice<T>[] = []
  let cursor = 0
  for (const group of groups) {
    const next = cursor + group.count
    slices.push({ ...group, articles: articles.slice(cursor, next) })
    cursor = next
  }
  // Append any remaining articles that fell outside the configured groups so
  // they remain reachable in the sidebar even if counts drift.
  if (cursor < articles.length) {
    slices.push({ count: articles.length - cursor, articles: articles.slice(cursor) })
  }
  return slices
}
